import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { OrderablePackaging, viewOrderItemByIdAtom } from '../orders/state/state';

export default function useOrderItem(id: string): OrderablePackaging | undefined {
  const itemOrderAtom = useMemo(() => viewOrderItemByIdAtom(id), [id]);

  return useAtomValue(itemOrderAtom);
}
